import * as React from 'react';

const twitterIconDark = (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_22750_23242)">
    <path d="M16.7899 2.69745H19.8413L13.1748 10.3169L21.0174 20.6852H14.8767L10.067 14.3969L4.5637 20.6852H1.5104L8.64093 12.5354L1.11743 2.69745H7.41407L11.7616 8.44523L16.7899 2.69745ZM15.7189 18.8588H17.4097L6.49531 4.42796H4.68086L15.7189 18.8588Z" fill="#073572"/>
    </g>
    <defs>
    <clipPath id="clip0_22750_23242">
    <rect width="21.7091" height="21.7091" fill="white" transform="translate(0.212891 0.975281)"/>
    </clipPath>
    </defs>
    </svg>
);

export default twitterIconDark;
